import React, { useMemo, useReducer, createContext } from "react";
import { useDispatch } from "react-redux";
import {
  activateSession,
  deactivateSession,
  loadingSession,
} from "../actionTypes/providers";
import { resetHomeReducer } from "../slices/home";

export const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const dispatchRedux = useDispatch();
  const [state, dispatch] = useReducer(
    (_prevState, action) => {
      switch (action.type) {
        case activateSession:
          sessionStorage.setItem("session", "active");
          return {
            session: "active",
          };
        case deactivateSession:
          sessionStorage.setItem("session", "inactive");
          dispatchRedux(resetHomeReducer());
          return {
            session: "inactive",
          };
        case loadingSession:
        default:
          sessionStorage.setItem("session", "loading");
          return {
            session: "loading",
          };
      }
    },
    {
      session: sessionStorage.getItem("session") || "loading",
    }
  );

  const sessionContext = useMemo(
    () => ({
      activateSession: () => dispatch({ type: activateSession }),
      deactivateSession: () => dispatch({ type: deactivateSession }),
      loadingSession: () => {
        dispatch({ type: loadingSession });
      },
    }),
    []
  );
  return (
    <AuthContext.Provider value={{ sessionContext, ...state }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
